"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverTrackingLocationDto = void 0;
class DriverTrackingLocationDto {
}
exports.DriverTrackingLocationDto = DriverTrackingLocationDto;
//# sourceMappingURL=driver-tracking-location.dto.js.map